export const tag_popular_list_ko = [
"봄/여름"	,
"장식적인"	,
"벽지"	,
"포장지"	,
"보태니컬"	,
"예술적"	,
"손으로 그린"	,
"화려한"	,
"가을/겨울"	,
"현대의"	,
"수채화"	,
"현대의"	,
	
"그래픽"	,
"벡터 패턴"	,
"디지털"	,
"그래픽 패턴"	,
"나뭇잎"	,
"추상적인 꽃"	,
"여름"	,
"미술"	,
"꽃"	,
"큰 꽃"	,
"레이어"	,
"블로썸"	,
"빈티지"	,
"로맨틱"	,
"멀티 컬러"	,
"삽화"	,
"그래픽 꽃"	,
"이국적인"	,
"가을/겨울"	,
"푸른"	,
"레트로"	,
	
	
"야생화"	,
"분홍색"	,
"모양"	,
"용감한"	,
"나뭇잎"	,
"붓터치"	,
"윤곽"	,
"식물"	,
"밝은"	,
"장난기"	,
"예쁜"	,
"강렬한"	,
"정글"	,
"리조트"	,
"재미있는"	,
"녹색"	,
"한 여름"	,
"장식용"	,
"파스텔"	,
"번창한"	,
"단순한"	,
"봄"	,
"무채색"	,
"검정"	,
"단색화"	,
"노란색"	,
"그린"	,
"귀여운"	,
"빨간색"	,
"장미"	,
"표범무늬"	,
"점"	,
"사람들"	,
"섬세한"	,
"잔꽃무늬"	,
"어두운"	,
"사이키델릭한"	,
"손바닥"	,
"여자"	,
"최소의"	,
"주황색"	,
"하얀색"	,
"선"	,
"대규모"	,
"갈색"	,
"보라색"	,
"가을"	,
"하와이안"	,
"파란색 & 흰색"	,
"점"	,
"페이즐리"	,
"스케치"	,
"색조의"	,
"아프리카의"	,
"타이다이"	,
"대칭"	,
	
"꽃다발"	,
"낙서"	,
"회색"	,
"실루엣"	,
"민속학의"	,
"새"	,
"지그재그"	,
"동양의"	,
"가을"	,
"모티프"	,
"원"	,
"진한 블루"	,
"패치워크"	,
"파도"	,
"크림색"	,
"그런지"	,
"숲"	,
"1970년대"	,
"얼룩말"	,
"모더니즘"	,
"모자이크"	,
"겨울"	,
	
"사각형"	,
"호랑이"	,
"잉크"	,
"옵티컬"	,
	
"꽃잎"	,
"과일"	,
"인디언"	,
"바틱염색"	,
"1980년대"	,
"콜라주"	,
"삼각형"	,
"산호색"	,
"왜곡된"	,
"데이지"	,
"소규모"	,
"흐릿한"	,
"인디고"	,
"대리석"	,
"물"	,
"미래"	,
	
"남색"	,
"빛"	,
"제비꽃"	,
"순진한"	,
"혼합 미디어"	,
"만화경"	,
"라일락"	,
"터키석"	,
"모란"	,
	
"금"	,
"일본의"	,
"목초지"	,
"반다나"	,
	
"소용돌이"	,
"이카트"	,
"나비"	,
"1990년대"	,
"사진"	,
"휴가"	,
"네온"	,
"거리 미술"	,
"1960년대"	,
"짙은 녹색"	,
"대양"	,
"인상파"	,
"낙서하다"	,
"스카프"	,
"마젠타"	,
"백합"	,
"다이아몬드"	,
"청록색"	,
"북유럽의"	,
"모로코"	,
"별"	,
"장미"	,
"나무"	,
"히비스커스"	,
"난초"	,
"그래피티"	,
"거울"	,
"바로크"	,
"자수"	,
"만화"	,
"뱀"	,
"아즈텍"	,
	
"건축"	,
"레이스"	,
"아르누보"	,
"옴브레"	,
"양귀비"	,
	
	
"엮다"	,
"청록색"	,
"선박의"	,
"우주"	,
"풍경"	,
"시보리"	,
"은하"	,
"셰브런"	,
"만다라"	,
"기모노"	,
"중국풍의"	,
"핫핑크색"	,
"풀라드"	,
"음식"	,
"크리스마스"	,
"생선"	,
"하트"	,
"무지개색"	,
"간격"	,
"곤충"	,
"튤립"	,
"스텐실"	,
"시든"	,
"양치식물"	,
"고양이"	,
"레몬"	,
"깃털"	,
"1940년대"	,
"자카드"	,
"멕시칸"	,
"타탄"	,
"바우 하우스"	,
	
	
"픽셀"	,
	
"쇠사슬"	,
"바나나"	,
"라벤더"	,
"구름"	,
"목련"	,
"3D"	,
"1950년대"	,
"펑크"	,
"선인장"	,
"보석"	,
"앵무새"	,
"기린"	,
"채소"	,
"사탕"	,
"사람들"	,
"플라밍고"	,
"파인애플"	,
"하운드투스"	,
	
"고딕"	,
"딸기"	,
"니트"	,
	
"붓꽃"	,
"말"	,
"체리"	,
"깅엄 체크"	,
"발렌타인"	,
"편지"	,
"과자"	,
"대나무"	,
"은"	,
"할로윈"	,
"여름 축제"	,
"개"	,
"팬지"	,
"사과"	,
"나방"	,
"불가사리"	,
"수선화"	,
	
"헤링본"	,
"딱정벌레"	,
"코끼리"	,
"토끼"	,
"보트"	,
"아이스크림"	,
"두개골"	,
"고래"	,
"음료수"	,
	
"자동차"	,
"돌고래"	,
"개구리"	,
"번호"	]